import { NOOR } from "@/constants/testIds/noor";

const EXPLORE_LINKS = [
  { href: "#heritage", label: "Heritage" },
  { href: "#craft", label: "Craft" },
  { href: "#tasting", label: "Tasting" },
  { href: "#gallery", label: "Gallery" },
  { href: "/cocktails", label: "Cocktails" },
  { href: "/stockists", label: "Where to find" },
  { href: "/manifesto", label: "Manifesto" },
];

const HOUSE_LINKS = [
  { href: "/inner-circle", label: "Inner Circle" },
  { href: "#reserve", label: "Reserve a bottle" },
  { href: "#contact", label: "Trade & Press" },
  { href: null, label: "hello@noor.house" },
  { href: null, label: "Jalisco · México" },
];

// Reflect the new dual-age policy in the legal copy.
const RESPONSIBILITY_COPY =
  "Please enjoy NOOR responsibly. Sold only to persons of legal drinking age — 21+ in the United States, 19+ in most other markets. Tequila Blanco · 100% Agave Azul · 40% ALC. VOL · 750 ml.";

function FooterLinks({ title, items }) {
  return (
    <div>
      <p className="overline mb-5">{title}</p>
      <ul className="space-y-3 text-sm" style={{ color: "var(--text-secondary)" }}>
        {items.map((it) => (
          <li key={it.label}>
            {it.href ? (
              <a href={it.href} className="hover:text-[var(--accent-rose)] transition-colors">{it.label}</a>
            ) : (
              it.label
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

function FooterBrand() {
  return (
    <div className="col-span-12 md:col-span-5">
      <p className="font-display text-3xl tracking-[0.2em]" style={{ color: "var(--accent-rose)" }}>
        NOOR
      </p>
      <p className="mt-4 text-sm font-light max-w-sm" style={{ color: "var(--text-secondary)" }}>
        A small-batch tequila blanco bottled in jewelled crystal — born of agave, raised in light.
      </p>
    </div>
  );
}

function FooterCopyright() {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <p
        data-testid={NOOR.footerDisclaimer}
        className="text-xs max-w-xl leading-relaxed"
        style={{ color: "var(--text-secondary)" }}
      >
        {RESPONSIBILITY_COPY}
      </p>
      <p className="text-xs tracking-[0.25em] uppercase" style={{ color: "var(--text-secondary)" }}>
        © {new Date().getFullYear()} Noor · All rights reserved
      </p>
    </div>
  );
}

export default function Footer() {
  return (
    <footer
      data-testid={NOOR.footerSection}
      className="relative pt-24 pb-12"
      style={{ borderTop: "1px solid var(--border-subtle)" }}
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10 mb-16">
          <FooterBrand />
          <div className="col-span-6 md:col-span-3">
            <FooterLinks title="Explore" items={EXPLORE_LINKS} />
          </div>
          <div className="col-span-6 md:col-span-4">
            <FooterLinks title="House" items={HOUSE_LINKS} />
          </div>
        </div>

        <div className="hairline mb-8" />

        <FooterCopyright />
      </div>
    </footer>
  );
}
